import Cookies from 'js-cookie';

// Set cookie domain to parent domain, so that it can be accessed by all subdomains
// Duplicated in eval, any changes have to be made there too
export const JS_COOKIE = Cookies.withAttributes({
  domain: window.location.hostname.split('.').slice(1).join('.'),
  expires: 1,
});
